import { CONFERENCE_LEFT } from '../base/conference/actionTypes';
import { PARTICIPANT_LEFT } from '../base/participants/actionTypes';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { TRACK_REMOVED, TRACK_UPDATED } from '../base/tracks/actionTypes';
import { HELD_FRAME_RELEASE_AFTER_PLAY_MS } from './heldFrame';
import { holdRemoteFrame, releaseHeldFrame } from './heldFrames.web';
/** The remote video track in a track action, with whose it is. */
function remoteVideo(track) {
    const jitsiTrack = track?.jitsiTrack;
    try {
        const participantId = jitsiTrack?.getParticipantId?.();
        return jitsiTrack && participantId && jitsiTrack.isLocal?.() === false && jitsiTrack.getType?.() === 'video'
            ? { jitsiTrack, participantId } : undefined;
    }
    catch {
        return undefined;
    }
}
/**
 * The held last frame of a remote video across a move between the direct
 * connection and the bridge (heldFrames.web.ts): taken before the reducer
 * drops the outgoing track, while its element still shows the frame, and let
 * go once the new track has played and faded in over it, or the person left.
 */
MiddlewareRegistry.register(store => next => action => {
    if (action.type === TRACK_REMOVED) {
        const removed = remoteVideo(action.track);
        const conference = store.getState()['features/base/conference'].conference;
        if (removed && conference?.getParticipantById?.(removed.participantId)) {
            holdRemoteFrame(removed.participantId, removed.jitsiTrack);
        }
    }
    const result = next(action);
    switch (action.type) {
        case TRACK_UPDATED: {
            const started = action.track?.videoStarted === true ? remoteVideo(action.track) : undefined;
            if (started) {
                const playedAt = Date.now();
                // After the new video's fade-in, which the held frame sits under;
                // a frame held again since (another move) stays.
                setTimeout(() => releaseHeldFrame(started.participantId, playedAt), HELD_FRAME_RELEASE_AFTER_PLAY_MS);
            }
            break;
        }
        case PARTICIPANT_LEFT:
            releaseHeldFrame(action.participant?.id);
            break;
        case CONFERENCE_LEFT:
            releaseHeldFrame();
            break;
    }
    return result;
});
